(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ModeleContratDeleteController',ModeleContratDeleteController);

    ModeleContratDeleteController.$inject = ['$uibModalInstance', 'entity', 'ModeleContrat'];

    function ModeleContratDeleteController($uibModalInstance, entity, ModeleContrat) {
        var vm = this;
        vm.modeleContrat = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            ModeleContrat.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
